/* "Add both to cart" for the PDP Stack & save cards ([data-stk-add]="vid1,vid2"). Oct 26 2026.
   Adds this product + the paired one in one /cart/add.js call, refreshes the Horizon cart drawer and opens it.
   The customer stays on the page. Sold-out pairs render disabled from Liquid; a 422 here also flips to Sold out. */
(function(){
  if (window.__donStkAdd) return; window.__donStkAdd = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function openDrawer(html){
    var d = document.getElementById('cart-drawer');
    if (html && d){
      try{
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ni = doc.querySelector('.cart-drawer__inner'), oi = d.querySelector('.cart-drawer__inner');
        if (ni && oi){ oi.replaceWith(document.importNode(ni, true)); }
      }catch(e){}
    }
    if (d && typeof d.open === 'function'){ try{ d.open(); return true; }catch(e){} }
    return false;
  }
  function msg(b, t){
    var c = b.closest('.dsx-stk-c'); var m = c && c.querySelector('[data-stk-msg]');
    if (m){ m.textContent = t; m.hidden = !t; }
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-stk-add]'); if (!b) return;
    e.preventDefault();
    if (b.disabled || b.getAttribute('aria-busy') === 'true') return;
    var ids = (b.getAttribute('data-stk-add') || '').split(',').map(Number).filter(Boolean);
    if (!ids.length) return;
    var lab = b.querySelector('[data-stk-label]'); var old = lab ? lab.textContent : '';
    b.setAttribute('aria-busy','true'); if (lab) lab.textContent = 'Adding…'; msg(b,'');
    var body = { items: ids.map(function(id){ return { id: id, quantity: 1 }; }), sections: 'cart-drawer-section', sections_url: location.pathname };
    fetch(root + 'cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok){ j.__status = r.status; throw j; } return j; }); })
      .then(function(j){
        b.removeAttribute('aria-busy'); if (lab) lab.textContent = 'Added ✓';
        setTimeout(function(){ if (lab) lab.textContent = old; }, 2200);
        var html = j && j.sections && j.sections['cart-drawer-section'];
        try{ var ev = new Event('cart:update', { bubbles:true }); document.dispatchEvent(ev); }catch(x){}
        if (!openDrawer(html)) msg(b, 'Added to cart');
      })
      .catch(function(err){
        b.removeAttribute('aria-busy');
        var t = (err && (err.description || err.message)) || '';
        if (err && err.__status === 422 && /sold out|unavailable|stock/i.test(t + ' ' + (err.message||''))){
          b.disabled = true; if (lab) lab.textContent = 'Sold out'; var pr = b.querySelector('[data-stk-price]'); if (pr) pr.hidden = true;
        } else {
          if (lab) lab.textContent = old; msg(b, 'Could not add to cart. Please try again.');
        }
      });
  });
})();
